<script>
  import ListMain from '../../../../../app/components/list/Main.vue'
  import ListHeader from '../../../../../app/components/list/Header.vue'
  import ListShowButton from '../../../../../app/components/list/ShowButton.vue'
  import ListEditButton from '../../../../../app/components/list/EditButton.vue'
  import ListDeleteButton from '../../../../../app/components/list/DeleteButton.vue'
  import PaperStatusLabel from './paper/PaperStatusLabel'
  import PaperShow from './paper/PaperShow'
  import PaperEvaluationsLabel from './labels/PaperEvaluationsLabel.vue'

  import * as restfulService from '../../../../services/restfulService'
  import * as notifyService from '../../../../services/notifyService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapGetters} from 'vuex'

  let defaultSearchData = {
    event_id: null,
    status: []
  }

  export default {
    components: {
      ListMain,
      ListHeader,
      ListShowButton,
      ListEditButton,
      ListDeleteButton,
      PaperStatusLabel,
      PaperShow,
      PaperEvaluationsLabel
    },
    mixins: [helpers],
    data () {
      return {
        isLoadingData: true,
        isSubmitted: false,
        isPaperVisible: false,
        statusKey: '',
        filters: {
          id: ''
        },
        dependencies: {},
        paper: {
          notes: ''
        }
      }
    },
    watch: {
      '$route' (to) {
        if (to.name === 'event.index.papers') {
          this.loadList()
        }
      }
    },
    mounted () {
      this.loadList()
      bus.$on('papers-reload-list', () => {
        this.loadList()
      })
    },
    computed: {
      ...mapGetters(['listStore']),
      isOnEvaluation: function () {
        return this.$route.params.statusKey === 'em_avaliacao'
      },
      allPapersEvaluated: function () {
        return this.listStore.listData.every((item) => {
          return item.reviews
            .filter(review => review.last_action.status.key === 'atribuido' ||
              review.last_action.status.key === 'aceito' ||
              review.last_action.status.key === 'avaliado').length === item.reviews.filter(review => review.last_action.status.key === 'avaliado').length
        })
      },
      listFiltered: function () {
        if (this.isOnEvaluation) {
          return this.listStore.listData.sort((a, b) => {
            if (!a.event_paper_type.evaluation_type) {
              return 0
            } else {
              return (this.getEvaluationProgress(a) > this.getEvaluationProgress(b)) ? 1 : ((this.getEvaluationProgress(b) > this.getEvaluationProgress(a)) ? -1 : 0)
            }
          })
        }
        return this.listStore.listData
      }
    },
    methods: {
      loadList () {
        this.isPaperVisible = false
        const id = this.$route.params.id || null
        const statusKey = this.$route.params.statusKey || null
        this.statusKey = statusKey
        let perPage = this.listStore.listPerPage
        let searchData = {
          event_id: id,
          status: null
        }
        if (statusKey) {
          searchData.status = []
          searchData.status.push(statusKey)
          if (statusKey === 'finalizado') {
            searchData.status.push('reprovado')
            searchData.status.push('aguardando_publicacao')
          }
        }
        if (statusKey === 'em_avaliacao') {
          perPage = 'all'
        }
        defaultSearchData = Object.assign({}, searchData)
        bus.$emit('list-init', {
          domain: 'paper',
          route: 'manager',
          customSearch: true,
          data: searchData,
          perPage: perPage
        }, () => {
          bus.$emit('hide-loader')
          this.isLoadingData = false
        })
      },
      onFilter () {
        let searchData = Object.assign({}, defaultSearchData)
        if (this.filters.id) {
          searchData.id = this.filters.id
        }
        bus.$emit('list-filter', this.filters, searchData)
      },
      onFilterClean () {
        this.filters = {}
        bus.$emit('list-filter-clean', this.filters, defaultSearchData)
      },
      onDestroy (item) {
        bus.$emit('list-destroy-item', item)
      },
      getEvaluationProgress (paper) {
        let reviews = paper.reviews.filter(item => item.last_action.status.key === 'atribuido' || item.last_action.status.key === 'aceito' || item.last_action.status.key === 'avaliado')
        let minEvaluationsNumber = paper.event_paper_type.evaluation_type.min_evaluations_number
        let reviewsEvaluated = paper.reviews.filter(item => item.last_action.status.key === 'avaliado')
        if (reviews.length > 0) {
          if (reviews.length > minEvaluationsNumber) {
            minEvaluationsNumber = reviews.length
          }
          return parseInt((reviewsEvaluated.length * 100) / minEvaluationsNumber)
        }
        return 0
      },
      getTotalAvaliacoesInloco (reviews) {
        let statusAllowed = [3, 7, 8]
        let reviewsInloco = reviews.filter(
          item => (statusAllowed.indexOf(item.last_action.paper_status_id) > -1) && (item.event_paper_type_evaluation_type.evaluation_type_id === 2)
        )
        return reviewsInloco.length
      },
      isInvoicePaid: function (paper) {
        console.log(paper.registration.status.key)
        return (paper.registration.status.key === 'pago' || paper.registration.status.key === 'sem_custo')
      },
      isEditDaysAvailable: function (paper) {
        return paper.event_paper_type.edit_limit_days > 0 &&
          this.momentInstance(paper.date_submitted)
            .add(paper.event_paper_type.edit_limit_days, 'days')
            .isBetween(
              this.momentNow(),
              this.momentNow().add(paper.event_paper_type.edit_limit_days, 'days')
            )
      },
      canBeApproved: function (paper) {
        return (this.isInvoicePaid(paper) && paper.event_paper_type.edit_limit_days === 0) ||
          (this.isInvoicePaid(paper) && !this.isEditDaysAvailable(paper))
      },
      showPaper (paper) {
        bus.$emit('show-loader')
        this.isPaperVisible = false
        restfulService.get('paper', 'manage', paper.id)
          .then((response) => {
            this.paper = response
            this.isPaperVisible = true
            setTimeout(() => {
              this.$scrollTo('#paper-content')
              bus.$emit('hide-loader')
            }, 500)
          })
          .catch(e => {
            this.isPaperVisible = false
            console.log(e)
          })
      },
      onSavePaper (data) {
        bus.$emit('show-loader')
        this.isSubmitted = true
        restfulService.put('paper', 'update-status', data.id, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.isPaperVisible = false
            this.paper = {}
            this.loadList()
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      },
      onFinishPapersWeb () {
        bus.$emit('show-loader')
        this.isSubmitted = true
        let data = {}
        let eventId = this.$route.params.id
        restfulService.put('event', 'finish-papers-web', eventId, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.isPaperVisible = false
            this.paper = {}
            this.loadList()
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    },
    beforeMount () {
      this.listStore.listData = []
    },
    beforeDestroy () {
      bus.$off('papers-reload-list')
    }
  }
</script>

<template>
    <div>
        <div class="header header-flex">
            <h2>Lista de Submissões</h2>
            <el-button type="success"
                       v-if="statusKey === 'em_avaliacao' && this.listStore.listData.length"
                       :disabled="!allPapersEvaluated && true"
                       @click="onFinishPapersWeb">
                <i class="fa fa-check"></i>
                <span>Finalizar Todas Avaliações</span>
            </el-button>
        </div>
        <ListMain>
            <div slot="filters">
                <el-card class="el-card__search_list box-card">
                    <div slot="header">
                        <span>Filtrar Listagem</span>
                        <div>
                            <el-button type="primary" @click="onFilter">Pesquisar</el-button>
                            <el-button type="default" @click="onFilterClean">Limpar</el-button>
                        </div>
                    </div>
                    <el-form :inline="true" :model="filters" class="demo-form-inline">
                        <el-form-item label="Código">
                            <el-input v-model="filters.id"
                                      placeholder="Filtrar por Código"/>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div>

            <div slot="list" v-if="!isLoadingData">
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>Código</th>
                        <th>Autor</th>
                        <th>Data da Submissão</th>
                        <th>Status</th>
                        <th>Avaliadores In Loco</th>
                        <th v-if="isOnEvaluation" width="140">Avaliações</th>
                        <th class="btn-actions">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listFiltered">
                        <td>{{item.id}}</td>
                        <td>{{item.registration.person.pessoa ? item.registration.person.pessoa.nome : 'Cadastro não encontrado no Segue'}} ({{item.registration.person.ref_pessoa}})</td>
                        <td>{{item.date_submitted | dateTimeEnToBr}}</td>
                        <td>
                            <div>
                                <paper-status-label :status-id="item.paper_status_id"
                                                    :status-key="item.status.key"
                                                    :status-name="item.status.name"/>
                            </div>
                            <div class="small">Última Atualização: {{item.last_modified | dateTimeEnToBr }}</div>
                        </td>
                        <td>
                          <paper-evaluations-label :evaluations="getTotalAvaliacoesInloco(item.reviews)"></paper-evaluations-label>
                        </td>
                        <td v-if="isOnEvaluation && item.event_paper_type.evaluation_type">
                            <el-progress :percentage="getEvaluationProgress(item)"
                                         :stroke-width="18"
                                         :text-inside="true"/>
                        </td>
                        <td v-if="isOnEvaluation && !item.event_paper_type.evaluation_type">
                            Avaliações fora do período
                        </td>
                        <td align="center">
                            <el-button type="default"
                                       @click="showPaper(item)"
                                       :disabled="!canBeApproved(item)"
                                       size="mini"
                                       :title="canBeApproved(item) ? 'Visualizar Trabalho' : 'Trabalho indisponível'">
                                <i class="fa fa-eye"></i>
                            </el-button>
                            <a :href="item.file.download_file_path"
                               v-if="item.file"
                               target="_blank"
                               class="el-button el-button--info el-button--mini"
                               title="Baixar arquivo">
                                <i class="fa fa-download"></i>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </ListMain>
        <div v-if="isPaperVisible" id="paper-content">
            <paper-show :model="paper" :load-list="loadList"/>
        </div>
    </div>
</template>




// WEBPACK FOOTER //
// Papers.vue?6564eee4